import { SVGProps } from '@components/Icon/types';

export const ClientFeedback = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}>
    <path
      d="M9.09668 1.25781C9.46843 0.514309 10.5286 0.514329 10.9004 1.25781L12.6406 4.73828C12.9075 5.27115 13.4163 5.64255 14.0059 5.7334L18.4395 6.41504C19.2563 6.54082 19.5836 7.54149 19 8.125L16.0127 11.1123C15.5986 11.5264 15.4061 12.1136 15.4951 12.6924L16.1787 17.1348C16.3041 17.9516 15.4482 18.5637 14.7158 18.1816L10.8496 16.165H10.8486C10.3821 15.9224 9.83845 15.8921 9.35254 16.0742L9.14746 16.165L5.28223 18.1816C4.54927 18.5639 3.693 17.9516 3.81836 17.1348L4.50195 12.6924C4.59093 12.1136 4.39847 11.5264 3.98437 11.1123L0.99707 8.125C0.413213 7.54068 0.74073 6.54078 1.55762 6.41504L5.99121 5.7334C6.50714 5.65392 6.96097 5.35995 7.24512 4.93066L7.35645 4.73828L9.09668 1.25781Z"
      stroke={fill}
      strokeWidth={3.5}
      transform="translate(8, 9.54) scale(0.4)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6318 2C15.1749 2 15.6563 2.26916 15.9326 2.67285H17.5801C18.9194 2.67285 19.9998 3.6888 20 4.9502V19.7227C19.9997 20.984 18.9194 22 17.5801 22H6.41992C5.08062 22 4.00027 20.984 4 19.7227V4.9502C4.00016 3.71644 5.03337 2.71797 6.33203 2.6748L8.06445 2.67773C8.34027 2.2714 8.82297 2 9.36816 2H14.6318ZM6.41992 3.94531C5.82377 3.94531 5.35172 4.39002 5.35156 4.9502V19.7227C5.35182 20.2828 5.82383 20.7275 6.41992 20.7275H17.5801C18.1762 20.7275 18.6482 20.2828 18.6484 19.7227V4.9502C18.6483 4.39002 18.1762 3.94531 17.5801 3.94531H16.1797V4.55273C16.1797 5.35395 15.481 6.0127 14.6318 6.0127H9.36816C8.51897 6.0127 7.82129 5.35395 7.82129 4.55273V3.94434L6.41992 3.94531ZM9.36816 3.19824C9.36816 3.19824 9.26284 3.18155 9.13281 3.26758C9.0076 3.35051 9.00309 3.45187 9.00293 3.45898V4.55273C9.00293 4.55273 9.00289 4.66179 9.08203 4.72559C9.22217 4.83854 9.36816 4.81445 9.36816 4.81445H14.6318C14.6318 4.81445 14.7372 4.83017 14.8672 4.74414C14.9969 4.65815 14.9971 4.55273 14.9971 4.55273V3.45898C14.997 3.45175 14.9941 3.34866 14.918 3.28711C14.7778 3.17415 14.6318 3.19824 14.6318 3.19824H9.36816Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'client-feedback';
